import { mdiShoppingOutline } from '@mdi/js'

export default [
  {
    title: 'مارکتینگ',
    icon: mdiShoppingOutline,
    action: 'can_see_marketing_menu',
    resource: 'all',
    children: [
      {
        title: 'تخفیف های مدیریتی',
        to: 'discount-code',
        action: 'can_see_discount_code',
        resource: 'all',
      },
      {
        title: 'تخفیفات',
        to: 'support-discount-code',
        action: 'can_see_low_privileged_discount_code',
        resource: 'all',
      },
      {
        title: 'تنظیمات',
        to: 'setting',
        action: 'can_see_marketing_setting',
        resource: 'all',
      },
      {
        title: 'کوتاه کننده لینک',
        to: 'short-link',
        action: 'can_edit_short_links',
        resource: 'all',
      },
      {
        to: 'login-notice',
        title: 'اعلانات ورود',
        resource: 'all',
        action: 'can_see_login_popup',
      },
    ],
  },
]
